window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Filter  Script
 * ------------------------------------------------------------------------------
 * Will triggers <select> changes on collection and cart pages.
 *
 * @namespace filters
 */
 
slate.Filters = (function() {
	var constants = {
		SORT_BY: 'sort_by'
	};
	var selectors = {
		filterSelection			: '[filters-filter]',
		sortSelection			: '[filters-sort]',
		defaultSort				: '[filters-default-sort]'
	};
	
	/**
	 * Filters constructor. 
	 * @param {string} container - selector for the section container DOM element
	 */
	function Filters(container) {
		this.$container = this.$container = $(container);

	    this.$filterSelect = $(selectors.filterSelection, this.$container);
	    this.$sortSelect = $(selectors.sortSelection, this.$container);
	    this.$selects = $(selectors.filterSelection, this.$container).add($(selectors.sortSelection, this.$container));
	
	    this.defaultSort = this._getDefaultSortValue();
	    this.$selects.removeClass('hidden');
	
	    this.$filterSelect.on('change', this._onFilterChange.bind(this));
	    this.$sortSelect.on('change', this._onSortChange.bind(this));
	}
	
	
	Filters.prototype = $.extend({}, Filters.prototype, {
		_onSortChange: function(evt) {
			var sort = this._sortValue();
			if (sort.length) {
				window.location.search = sort;
			} else {
				// clean up our url if the sort value is blank for default
				window.location.href = window.location.href.replace(window.location.search, '');
			}
		},
		
		_onFilterChange: function(evt) {
			window.location.href = this.$filterSelect.val() + window.location.search;
		},
		
		_getSortValue: function() {
			return this.$sortSelect.val() || this.defaultSort;
		},
		
		_getDefaultSortValue: function() {
			return $(selectors.defaultSort, this.$container).val();
		},
		
		_sortValue: function() {
			var sort = this._getSortValue();
			var query = '';
		
			if (sort !== this.defaultSort)
				query = constants.SORT_BY + '=' + sort;
				
			return query;
		}
	});
	
	return Filters;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
	 * @namespace product
 */

theme.Product = (function() {

	var selectors = {
		addToCart: '[data-add-to-cart]',
		addToCartBtn: '.btn[name="add"]',
		addToCartText: '[data-add-to-cart-text]',
		extraAddToCart: '[data-extra-add-to-cart]',
		comparePrice: '[data-compare-price]',
		comparePriceText: '[data-compare-text]',
		originalSelectorId: '[data-product-select]',
		priceWrapper: '[data-price-wrapper]',
		featuredImgWrapper: '.featured-img-wrapper',
		productFeaturedImage: '[data-product-featured-image]',
		productJson: '[data-product-json]',
		productPrice: '[data-product-price]',
		productThumbs: '[data-product-single-thumbnail]',
		singleOptionSelector: '[data-single-option-selector]',
		variantSKU: '[data-variant-sku]'
	};


	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Product(container) {
		this.$container = $(container);

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson, this.$container).html()) return;

		var sectionId = this.$container.attr('data-section-id');
		this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
		var options = {
			$container: this.$container,
			enableHistoryState: this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productSingleObject
		};

		this.settings 				= {};
		this.namespace 				= '.product';
		this.variants 				= new slate.Variants(options);
		this.$featuredImage 		= $(selectors.productFeaturedImage, this.$container);
		this.$featuredImgWrapper	= $(selectors.featuredImgWrapper, this.$container);
		this.$addToCart				= $(selectors.addToCart);
		this.$addToCartBtn			= $(selectors.addToCartBtn);
		this.$productThumbs 		= $(selectors.productThumbs, this.$container);
		this.$extraAddToCart		= $(selectors.extraAddToCart);
		this.singleOptionSelector 	= $(selectors.singleOptionSelector, this.$container);
		this.variantSKU				= $(selectors.variantSKU, this.$container);

		this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
		this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
		
		// On Variant Thumbnail click
		this.$productThumbs.on('click', this.switchImage.bind(this));
		
		// Add to cart Btn
		this.$addToCartBtn.on('click', this.addTocartEvent.bind(this));
		this.$extraAddToCart.on('click', function(e) {
			e.preventDefault();
			this.$addToCartBtn.trigger('click');
		}.bind(this));

		// INIT PP CHECK EVENT (for drawer cart)
		this.PPCheckEvent();

		if (this.$featuredImage.length > 0) {
			this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));			
			slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
			this.$container.on('variantImageChange' + this.namespace, this.switchImage.bind(this));
		}
	}

	Product.prototype = $.extend({}, Product.prototype, {

		/**
		 * Global Event for PP check
		 * True > all good, false > some warnings 
		 * @param {Boolean} status
		 * @param {Boolean} skipAdd
		**/
		PPCheckEvent: function(status, skipAdd) {
			$(document).trigger('ppCheck', [status || false, skipAdd || false]);
		},
		
		/**
		 * Add to Cart click
		 * @param {Event} e
		**/
		addTocartEvent: function(e) {
			var $target = $(e.currentTarget);
			
			if ($target.hasClass('drawer-active')) {
				e.preventDefault();
				this.PPCheckEvent(true, false);
			}
		},

		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function(evt) {
			var variant = evt.variant;
			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('hide');
				// Adjust variant sku display
				this.variantSKU.html('Item: '+variant.sku);
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$container).addClass('hide');
				return;
			}

			if (variant.available) {
				$(selectors.addToCart, this.$container).prop('disabled', false);
				this.$addToCart.data('variant-id', variant.id);
				$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
			}
		},

		/**
		 * Updates the DOM with specified prices
		 *
		 * @param {string} productPrice - The current price of the product
		 * @param {string} comparePrice - The original price of the product
		 */
		updateProductPrices: function(evt) {
			var variant = evt.variant;
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

			$(selectors.productPrice, this.$container)
				.html(Shopify.formatMoney(variant.price, theme.moneyFormat));

			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$compareEls.removeClass('hide');
			} else {
				$comparePrice.html('');
				$compareEls.addClass('hide');
			}
		},

		/**
		 * Updates the DOM with the specified image URL
		 *
		 * @param {string} src - Image src URL
		 */
		updateProductImage: function(evt) {
			var variant = evt.variant;
			var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

			this.$featuredImage.attr('src', sizedImgUrl);
		},
		
		/**
		 * Swith Featured image based on thumbnail click
		 *
		 * @param {Object} evt
		**/
		switchImage: function(evt) {
			evt.preventDefault();
			var imageSrc = null,
			 variant = evt.variant,
			 varID = $(evt.currentTarget).data('variant-id');
			 			
			// get image url
			if (variant)
				var imageSrc = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
			else
				var imageSrc = $(evt.currentTarget).attr('href')
				
			if (!imageSrc) return;
			
			// Change image
			this.$featuredImgWrapper.addClass('anim');
			setTimeout(function() {
				this.$featuredImage.attr('src', imageSrc);
			}.bind(this), 700);
			
			// Remove anim
			setTimeout(function() {
				this.$featuredImgWrapper.removeClass('anim');
			}.bind(this), 1600);
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function() {
			this.$container.off(this.namespace);
		}
	});

	return Product;
})();

/**
 * Cart Page Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the cart Section.
 * @namespace cart
**/
theme.Cart = (function() {
	var selectors = {
		cartLines					: '.cart-line',
		inputUpdates				: '[name="updates[]"]',
		cartNotes					: 'form [name="note"]',
		checkout					: 'input[name="checkout_clone"]',
		readTC						: '#readtc',
		TCwarning					: '[data-warning-tc]',
		quantity					: '[name="quantity"]',
		btnDelete					: '[data-btn-delete]'
	};
	
	
	/**
	 * Cart section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	*/
	function Cart(container) {
		this.$container 			= $(container);
		this.namespace 				= '.cart';
		var sectionId 				= this.$container.attr('data-section-id');

		this.$cartNotes				= $(selectors.cartNotes, this.$container);
		this.$checkout				= $(selectors.checkout, this.$container);
		
		this.$readTC				= $(selectors.readTC, this.$container);
		this.$TCwarning				= $(selectors.TCwarning, this.$container);
		this.tcAJAX					= null;
		this.returnAJAX				= null;
		this.userAcceptedTC			= false; // default
		
		this.$quantity				= $(selectors.quantity, this.$container);
		this.$btnDelete				= $(selectors.btnDelete, this.$container);
		this.$inputUpdates			= $(selectors.inputUpdates, this.$container);
		
		// Event Handlers \\
		// Accept term and conditions
		this.$readTC.on('click', this.acceptTC.bind(this));
		// Delete button
		this.$btnDelete.on('click', this.clickedBtnDelete.bind(this));
		// Click CHECKOUT
		this.$checkout.on('click', this.proceedToCheckout.bind(this));
		// Quantity input change
		this.$inputUpdates.on('changeProg keyup', this.qtyInputChange.bind(this));
		
		// HELPER Function
		/**
		 * Returned Debouncing function
		 *
		 * @param {Integer} qty
		 * @param {Integer} variantid
		 * @param {Function} callback
		 * 
		**/
		theme.Cart.returnedDebounceFunction = this.debounce(function() {
			var args = $.makeArray(arguments);
			  fn = args.pop();
			// Callback
			if (typeof fn === 'function')
				fn.apply(args); 
		}, 400);
		
		
		// INIT
		if (return_url) this.AJAXreturnPolicy();
		if (terms_url) this.AJAXreadTC();
		this.displayModalInfo();
	}
	
	
	Cart.prototype = $.extend({}, Cart.prototype, {
		
		/**
		 * Accept terms and conditions
		 * @param {Event} e
		**/
		acceptTC: function(e) {
			this.userAcceptedTC = ($(e.target).prop('checked') == true);
			if (this.userAcceptedTC)
				this.$TCwarning.addClass('d-none');
		},
		
		/**
		 * Proceed to checkout
		 * @param {Event} e
		**/
		proceedToCheckout: function(e) {
			var error = 0;
			this.$TCwarning.addClass('d-none');
			
			// TC accepted ?
			if (!this.userAcceptedTC) {
				this.$TCwarning.removeClass('d-none');
				error++;
			}
			
			// Stop process on error
			if (error > 0) {
				e.preventDefault();
				return false;
			}
			
			// Copy cart notes in the form
			this.cartExtraNotes();
			
			// Disable Button
			$(e.target).attr('disabled', 'disabled');
			
			// Send form
			$('input[name="checkout"]').trigger('click');
		},
		
		/**
		 * AJAX get details page for return
		 * policies in a modal page
		**/
		AJAXreturnPolicy: function() {	
			$.ajax({
				url: return_url,
				type: 'GET'
			})
			.done(function(data) {
				var $data = $(data),
				  title = $data.find('h1').html();
				  content = $data.find('.rte').html();
				
				this.returnAJAX = {
					title: title,
					content: content
				};
			}.bind(this));
		},
		
		/**
		 * AJAX get read terms and conditions
		**/
		AJAXreadTC: function() {
			$.ajax({
				url: terms_url,
				type: 'GET'
			})
			.done(function(data) {
				var $data = $(data),
				  title = $data.find('h1').html();
				  content = $data.find('.rte').html();
				this.tcAJAX = {
					title: title,
					content: content
				};
			}.bind(this));
		},
		
		/**
		 * Display Modal
		**/
		displayModalInfo: function() {
			$('#infoModal').on('show.bs.modal', function(e) {
				var $modal = $(e.target),
				  topic = $(e.relatedTarget).data('topic');
				
				if (topic == 'return-policy') {
					$modal.find('.modal-title').html(this.returnAJAX.title);
					$modal.find('#injectContent').html('').append(this.returnAJAX.content);
				} else if (topic == 'tc-details') {
					$modal.find('.modal-title').html(this.tcAJAX.title);
					$modal.find('#injectContent').html('').append(this.tcAJAX.content);
				}
				
			}.bind(this));
		},
		
		/** 
		 * Cart Extra Notes 
		 * when Check my plan active
		**/
		cartExtraNotes: function() {
			// Reset array
			var notes = $('#CartSpecialInstructions').val();
		
			if (notes)
				this.$cartNotes.val(notes);
		},

		/**
		 * handle Quantity input changes
		 *
		 * @param {Event} e
		**/
		qtyInputChange: function(e) {
			console.log('qtyInputChange');
			var $target = $(e.target),
			  variant_id = $target.data('variant-id'),
			  original_qty = ~~$target.data('original-qty'),
			  qty = ~~$target.val();
			
			// No change occured return
			if (qty == original_qty) return;
			
			// Debounce
			theme.Cart.returnedDebounceFunction(qty, variant_id, function() {
				// Set data update id: qty
				$('[name="update"]').trigger('click');
			}.bind(this));
		},
		
		/**
		 * Debouncing function
		 *
		 * @param {Function} func
		 * @param {Integer} wait
		 * @param {Boolean} immediate
		**/
		debounce: function(func, wait, immediate) {
			var timeout;
			return function() {
				var context = this, args = arguments;
				clearTimeout(timeout);
				// Moving this line above timeout assignment
				if (immediate && !timeout) func.apply(context, args);
				timeout = setTimeout(function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				}, wait);
			};
		},
			
		/**
		 * Delete item button
		 * trigger link
		**/
		clickedBtnDelete: function(e) {
			e.preventDefault();
			var id = $(e.currentTarget).data('remove-line');
			window.location.href = '/cart/change?line='+id+'&amp;quantity=0';
		}
		
	});
			
	return Cart;
})();
/**
 * Collection Smart Tags Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to this Section.
 * Collection Smart Tags
 * Two type of Smart tag
 * LENGTH: & SPEC:
 * @namespace collectionSmartTags
**/


theme.CollectionSmartTags = (function() {

	var selectors = {
		filterBy: 		'[name="filterBy"]'
	};
	
	
	/**
	 * Section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	*/
	function CollectionSmartTags(container) {
		this.$container 			= $(container);
		this.namespace 				= '.collectionSmartTags';
		var sectionId 				= this.$container.attr('data-section-id');

		this.$select				= $(selectors.filterBy, this.$container);
		this.smartTags				= [];

		// Handlers
		this.$select.on('change', this.onSelectChange.bind(this));

		this.getSmartTags();
	}
	
	CollectionSmartTags.prototype = $.extend({}, CollectionSmartTags.prototype, {
		
		/**
		 *  GET request to get all the data.
		 *  Call the populate Select function that adds the values to dropdown, and call clean tags function to 
		 * 	get the title of name from tag:
		**/
		getSmartTags: function() {
			if (!collection_tags) return;
			this.smartTags = collection_tags.split(',');
			this.populateSelect( this.cleanSmartTags() );
		},
		
		
		/**
		 * Clean the Smart Tags
		 * LENGTH: & SPEC:
		**/
		cleanSmartTags: function() {
			var tagsLen = this.smartTags.length, 
			  length_tags = [], spec_tags = [], tags, cleanTags = [],
			  i = 0, j = 0, typeLen;
	
			// GET LENGTH tags
			length_tags = $.grep(this.smartTags, function(t, index) {
				return t.toLowerCase().indexOf('length:') != -1;
			});
			
			
			// GET SPEC tags
			spec_tags = $.grep(this.smartTags, function(t, index) {
				return t.toLowerCase().indexOf('spec:') != -1;
			});
			
			// Merge the 2 arrays
			return $.merge(length_tags, spec_tags);
		},
		
		
		/** 
		 * Function that passes in an array from getRecipes function
		 * loops through the array to get the names of the tags.
		 * Injects html into blogRecipesSelector id
		 * @param {Array}
		**/
		populateSelect: function(arr) {
			var html = '<option value="-1">Filter by</option>',
			  urlTag = this.getUrlTag().toLowerCase();
			
			for (var i = 0; i < arr.length; i++) {
				var tag = arr[i].split(':');
				var selected = (urlTag == arr[i].toLowerCase()) ? ' selected="selected"' : '';
				var display = (tag[0] == 'LENGTH') ? 'Length: '+tag[1]+'"' : tag[1];
				html += '<option value="'+ arr[i] +'"'+ selected +'>' + display + '</option>';
			}
			this.$select.html(html);
		},
		
		
		/**
		 * On selector change.
		 * Gets the value of the selector
		 * calls getSelectedTags function with the value.
		**/ 
		onSelectChange: function(e) {
			var value = $(e.currentTarget).val();
			this.buildURL(value);
		},
		
		
		/**
		 * Build the URL
		 * @param {String} tag
		**/
		buildURL: function(tag) {
			// Split url into an array
			var urlArray = currentUrlPath.split('/'),
			  redirectURL, baseURL,
			  tagsArray = [],
			  i = 0, j;
			  
			// Shift first empty value ['', 'collections', 'all', ...]
			urlArray.shift();
			
			// Check url length to set the status
			if (urlArray.length <= 2) {
				// Add all to baseURL since none of them will be tags
				baseURL = urlArray;
			} else {
				// baseURL becomes every elemenet in urlArray except last element which is 'type:xyz'
				baseURL = urlArray.slice(0, urlArray.length-1)
			}
			
			// Set redirect url
			redirectURL = '/' + baseURL.join('/') + '/';
			
			// URL TAGS and Redirect
			redirectURL = redirectURL+tag+window.location.search;
			window.location.replace(redirectURL);
		},
		
		
		/**
		 * Get the smart tag from url
		 * @return {String}
		**/
		getUrlTag: function() {
			var urlArray = currentUrlPath.split('/'),
			  redirectURL, baseURL,
			  tagsArray = [],
			  i = 0, j;
			  
			// Shift first empty value ['', 'collections', 'all', ...]
			urlArray.shift();
			
			return urlArray.pop();
		}
		
	});
	return CollectionSmartTags;
})();
/**
 * Prodcut recommendation Section Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to this Section.
 * @namespace productRecommendation
**/


theme.ProductRecommendation = (function() {

	var selectors = {
		section: 		'[data-section-type="productRecommendation"]'
	};
	
	
	/**
	 * Section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	*/
	function ProductRecommendation(container) {
		this.$container 			= $(container);
		var sectionID 				= this.$container.attr('data-section-id');
		var productID 				= this.$container.data('product-id');
		var limit 					= this.$container.data('limit');
		this.productRecoUrl 		=  '/recommendations/products?&section_id='+sectionID+'&limit='+limit+'&product_id='+productID+' #reco';
		
		this.maxItems				= 4;
		
		// Init
		this.getRecommendations();
	}
	
	ProductRecommendation.prototype = $.extend({}, ProductRecommendation.prototype, {
		
		/**
		 *  LOAD request to get product recommendations.
		**/
		getRecommendations: function() {
			this.$container.parent().load(this.productRecoUrl, function() {
				this.initSlider();
			}.bind(this));
		},
		
		
		/**
		 * Init Template slider 
		**/
		initSlider: function() {
			var $slider = $('.template-slider', selectors.section),
			  slideLength = $slider.data('slide-length'),
			  initialized = $slider.hasClass('slick-initialized'),
			  toShow = (slideLength < this.maxItems) ? slideLength : this.maxItems;
			  
			// Return if already initialised
			if (initialized) return;

			$slider.slick({
				arrows: true,
				dots: false,
				slidesToShow: toShow,
				slidesToScroll: 1,
				responsive: [
				  {
					breakpoint: 768,
					settings: {
						centerMode: true,
						centerPadding: '55px',
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						arrows: false
					}
				  }
				]
			});
		}
		
		
	});
	return ProductRecommendation;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
	var $newAddressForm = $('#AddressNewForm');
	
	if (!$newAddressForm.length) return;
	
	// Initialize observers on address selectors, defined in shopify_common.js
	if (Shopify) {
		new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
			hideElement: 'AddressProvinceContainerNew'
		});
	}
	
	// Initialize each edit form's country/province selector
	$('.address-country-option').each(function() {
		var formId = $(this).data('form-id');
		var countrySelector = 'AddressCountry_' + formId;
		var provinceSelector = 'AddressProvince_' + formId;
		var containerSelector = 'AddressProvinceContainer_' + formId;
		
		new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
				hideElement: containerSelector
			});
		});
		
		// Toggle new/edit address forms
		$('.address-new-toggle').on('click', function() {
			$newAddressForm.toggleClass('d-block');
		});
		
		$('.address-edit-toggle').on('click', function() {
			var formId = $(this).data('form-id');
			$('#EditAddress_' + formId).toggleClass('d-block');
		});
		
		$('.address-delete').on('click', function() {
			var $el = $(this);
			var formId = $el.data('form-id');
			var confirmMessage = $el.data('confirm-message');
			if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
				Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
			}
		});
})();
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('d-none');
    $('#CustomerLoginForm').toggleClass('d-none');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('d-none');
  }
})();

/**
 * Contact Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Contact template.
 *
 * @namespace contact
 */
 theme.contact = (function() {
	 var selectors = {
		form			: '.contact-page #contact_form',
		nameInput		: '[name="contact[name]"]',
		emailInput		: '[name="contact[email]"]',
		messageInput	: '[name="contact[body]"]',
		submitBtn		: '#contact_form button[type="submit"]',
		errors			: '.errors',
		errorName		: '.error-name',
		errorEmail		: '.error-email',
		errorMessage	: '.error-message',
	};
	
	var $form = $(selectors.form),
	  $nameInput = $(selectors.nameInput),
	  $emailInput = $(selectors.emailInput),
	  $messageInput = $(selectors.messageInput),
	  $errors = $(selectors.errors);
	
	if ( !$form.length ) return;
	
	$(selectors.submitBtn).on('click', contactSubmitHandler);
	
	/**
	 * Handle submit
	**/
	function contactSubmitHandler (e) {
		var nameVal = $nameInput.val(), emailVal = $emailInput.val(), messageVal = $messageInput.val(),
		nameInvalid, emailInvalid, messageInvalid;
		
		// Reset errors
		$errors.addClass('d-none');
		$form.find('.form-control').removeClass('error');
		
		nameInvalid = (!nameVal || nameVal.length < 3);
		emailInvalid = (!emailVal || emailVal.length < 8 || (emailVal.indexOf('@')<0) || (emailVal.indexOf('.')<0));
		messageInvalid = (!messageVal || messageVal.length < 8);
		
		// Stop from sending
		if (nameInvalid || emailInvalid || messageInvalid)
			e.preventDefault();
		
		// Name error
		if (nameInvalid) {
			$(selectors.errorName).removeClass('d-none');
			$nameInput.addClass('error');
		}
		// Email error
		if (emailInvalid) {
			$(selectors.errorEmail).removeClass('d-none');
			$emailInput.addClass('error');
		}
		// Message error
		if (messageInvalid) {
			$(selectors.errorMessage).removeClass('d-none');
			$messageInput.addClass('error');
		}
	}
	
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('cart', theme.Cart);
  sections.register('collectionSmartTags', slate.Filters);
  sections.register('collectionSmartTags', theme.CollectionSmartTags);
  sections.register('productRecommendation', theme.ProductRecommendation);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'table-responsive',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

});


//====================================== //
//================ THEME =============== //
//====================================== //

/*
	Caching dom elements
*/
theme.selectors = function() {
	theme.cache = {
		$body					: $('html, body'),
		$actualPage				: $('body'),
		$mobileMenu				: $('.mobile-wrapper .navbar-toggler'),
		$mobileMenuRight		: $('.mobile-wrapper .mobile-right-menu'),
		$searchPredictions		: $('[data-search-predictions]'),
		$searchInput			: $('[name="q"]'),
		$closeNavInfo			: $('.navbar-collapse .close-nav-info'),
		$heroHome				: $('.template-index .hero'),
		$toScroll				: $('[data-to-scroll]'),
		$heroHomeVideo			: $('[hero-home-video]'),
		$slickHero				: $('#slick-hero'),
		$slickMobileBox         : $('#slick-mobile-box'),
		$infoHero				: $('#info-hero'),
		$sectionIntroLoopers	: $('.section-intro-loopers'),
		$templateSlider		    : $('.template-slider'),
		$relatedSlider			: $('.related-slider'),
		$pressSlider			: $('#pressSlider'),
		$testimonialSlider		: $('#testimonialSlider'),
		$dropdownCurrency		: $('.dropdown-currency .dropdown-item'),
		$currencyForm			: $('.shopify-currency-form select'),
		$mailchimpForm			: $('.mailchimp-form'),
		$vSlider				: $('.v-slider'),
		viewportWidth			: document.documentElement.clientWidth,
		sm						: 576,
		md						: 768,
		lg						: 992,
		xl						: 1200
	};
}


/**
	* Init key functions
**/
theme.init = function() {
	theme.selectors();
	theme.toScroll();
	
	// Menu
	if (theme.cache.viewportWidth < theme.cache.lg) {
		theme.mobileMenu();
	}
	
	// Currency
	theme.switchCurrency();

	// Homepage
	if (theme.cache.$actualPage.hasClass('template-index')) {
		theme.backgroundVideo();
		theme.heroSlider();
		theme.mobileBoxSlider();
		theme.infoHero();
		theme.homepageJS();
		if (theme.cache.$pressSlider.length)
			theme.pressSlider();
		if (theme.cache.$testimonialSlider.length)
			theme.testimonialSlider();
	}

	// Template slider Page
	if (theme.cache.$templateSlider.length) {
		theme.templateSlider();
	}

	// Template slider Page
	if (theme.cache.$relatedSlider.length) {
		theme.relatedSlider();
	}

	// Window resize
	theme.windowResize();

	//Search
	theme.liveSearch();
	
	//Mailchimp
	theme.mailchimp();
	
	// FORMS validation
	var $forms = theme.cache.$actualPage.find('form[data-validate="true"]');
	if ( $forms.length ) {
		theme.formsValidation($forms);
	}
}


theme.windowResize = function() {
	$(window).on('resize', function() {
		theme.cache.viewportWidth = document.documentElement.clientWidth;
		// Template Slider
		if (theme.cache.$templateSlider.length) {
			theme.templateSlider();
		}
		// Template Slider
		if (theme.cache.$relatedSlider.length) {
			theme.relatedSlider();
		}
		// Homepage
		if (theme.cache.$actualPage.hasClass('template-index')) {
			//theme.heroSlider();
			theme.homepageJS();
			theme.pressSlider();
		}
	});
}

/*******************************************
  HOMEPAGE
*******************************************/
/**
 * Homepage minor JS tricks
**/
theme.homepageJS = function() {
	if (theme.cache.viewportWidth >= theme.cache.md) {
		// LOOPERS SECTION
		var $introTextColumn = theme.cache.$sectionIntroLoopers.find('.intro-text-column'),
		  $introTextWrapper = theme.cache.$sectionIntroLoopers.find('blockquote'),
		  introTextWrapperHeight = $introTextWrapper.outerHeight();
	  
		// Set intro test parent height
		$introTextColumn.height( introTextWrapperHeight );
	}
}

/**
 * Currency switch
**/
theme.switchCurrency = function() {
	// Send Shopify currency form on change
	theme.cache.$currencyForm.on('change', function(e) {
		$(this).parents('form').submit();
	});
	
	theme.cache.$dropdownCurrency.on('click', function(e) {
		e.preventDefault();	
		var cur = $(this).data('currency');
		
		// Select item and Trigger Shopify currency form
		theme.cache.$currencyForm[0].value = cur;
		
		// Update button
		$('#dropdownCurrency').text(cur);
		
		// Trigger Shopify currency form
		theme.cache.$currencyForm.trigger('change');
	});
}

/**
 * Background Video - Youtube
 * Launch auto play
**/
theme.backgroundVideo = function() {
	var youtube_id, host;
	// Check if dome Element is there
	if (!theme.cache.$heroHomeVideo.length) return;
	youtube_id = theme.cache.$heroHomeVideo.data('youtube-id');
	host = theme.cache.$heroHomeVideo.data('request-host');
	
	// Check you tube ID
	if (!youtube_id) return;
	
	// YOUTUBE JS
	window.onYouTubeIframeAPIReady = function() {
		var player;
		player = new YT.Player('heroVideoPlayer', {
			videoId: youtube_id,	// YouTube Video ID
			playerVars: {
				height: "100%",
				width: "100%",
				autoplay: 1,		// Auto-play the video on load
				//autohide: 1,
				disablekb: 1, 
				controls: 0,		// Hide pause/play buttons in player
				showinfo: 0,		// Hide the video title
				modestbranding: 1,	// Hide the Youtube Logo
				html5: 1,
				playsinline: 1,
				loop: 1,			// Run the video in a loop
				fs: 0,				// Hide the full screen button
				autohide: 0,		// Hide video controls when playing
				rel: 0,
				enablejsapi: 1,
				iv_load_policy: 3,
				origin: host
			},
			events: {
				onReady: function(e) {
					e.target.mute();
					e.target.setPlaybackQuality('hd1080');
					e.target.playVideo();
				},
				onStateChange: function(e) {
					if (e && e.data > 0) {
						theme.cache.$heroHomeVideo.addClass('loading-off');
					} else if (e && e.data === 0) {
						e.target.playVideo();
					}
				}
			}
		});
	}
}

/**
 * Menu Mobile trigger
**/
theme.mobileMenu = function() {
	var $toHide = $('[data-form-to-reset]');
	
	theme.cache.$mobileMenu.on('click', function(e) {
		theme.cache.$mobileMenu.toggleClass('is-active');
	});
	
	theme.cache.$mobileMenuRight.on('click', 'a.nav-item', function(e) {
		var $this = $(this), 
		  $all = theme.cache.$mobileMenuRight.find('a.nav-item')
		  target = $(e.currentTarget).data('target');
		  
		// Switch panels
		switch (target) {
			case '#navbarCall':
				$('#navbarSearch').removeClass('show');
				resets();
				break;
			case '#navbarSearch':
				$('#navbarCall').removeClass('show');
				break;
		}
		
		  
		console.log( target, $(target) );
		  
		// Already active
		if ( $this.hasClass('isActive') ) {
			$all.removeClass('fade');
			$this.removeClass('isActive');
			resets();
			
		} else {
			// Opening
			$all.addClass('fade');
			$this.removeClass('fade')
			$this.addClass('isActive');
		}
	});
	
	theme.cache.$closeNavInfo.on('click', function(e) {
		theme.cache.$mobileMenuRight.find('a.nav-item').removeClass('fade isActive');
		resets();
	});
	
	// Reset views
	function resets() {
		setTimeout(function() {
			// Hide product predictions
			$toHide.addClass('off').removeClass('on').val('');
			// Reset input content
			theme.cache.$searchInput.val('');
		}, 200);
	}
}

/**
 * Init Hero slider
**/
theme.heroSlider = function() {
	var slider_auto = (typeof hero_slider_auto == 'undefined') ? false : hero_slider_auto;
	
	// Function
	function animation(slide) {
		  var $headingBox = slide.find('.heading-box'), 
		    boxHeight = $headingBox.height() - 15, 
		    marginValue = 0, 
		    screenWidth = window.screen.width;
		  
		// Adjust vertical position on mobile only
		if ( theme.cache.viewportWidth < theme.cache.md )
			$headingBox.css( 'transform', 'translateY('+boxHeight+'px)' );

		// Adjust margin of heading box
		if (boxHeight > 120)
			marginValue = 85;

		$headingBox.css( 'margin-bottom', ''+marginValue+'px' );
		
		// Apply classes 
		slide.find('.heading-wrapper').addClass('on');
		$headingBox.addClass('on');	
	}
	
	// Events
	theme.cache.$slickHero.on('init', function(event, slick) {
		if (slick.$slides) animation( slick.$slides.eq(0) );
	});
	theme.cache.$slickHero.on('afterChange', function(event, slick, currentSlide) {
		animation( slick.$slides.eq(currentSlide) );
	});

	theme.cache.$slickHero.slick({
		arrows: false,
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: slider_auto,
		autoplaySpeed: 3000,
		speed: 360,
		asNavFor: theme.cache.$slickMobileBox	
	});
}

theme.mobileBoxSlider = function() {

	theme.cache.$slickMobileBox.slick({
		arrows: false,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 3000,
		speed: 360,
		asNavFor: theme.cache.$slickHero
	});
}

/**
 * Init Hero slider
**/
theme.infoHero = function() {
	theme.cache.$infoHero.slick({
		arrows: true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 768,
				settings: {
				infinite: true,
				dots: true,
				arrows: false,
				slidesToShow: 1
			}
		  }
		]
	});
}

/**
 * Init Press slider
**/
theme.pressSlider = function() {
	var initialized = theme.cache.$pressSlider.hasClass('slick-initialized');
	
	// Return if already initialised
	if (initialized) return;
	
	// Force full height
	theme.cache.$pressSlider.on('init', function(event, slick) {
		slick.$slides.height( theme.cache.$pressSlider.outerHeight() );
	});
		
	theme.cache.$pressSlider.slick({
  		infinite: true,
  		arrows: true,
		dots: false,
		slidesToShow: 1,
  		slidesToScroll: 1,
  		responsive: [
		  {
	  		breakpoint: theme.cache.md,
	  		settings: {
		  		infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true
	 		 }
		  }
		]
	});
}

/**
 * Init Testimonial slider
**/
theme.testimonialSlider = function() {
	var initialized = theme.cache.$testimonialSlider.hasClass('slick-initialized');
	
	// Return if already initialised
	if (initialized) return;
		
	theme.cache.$testimonialSlider.slick({
  		infinite: true,
  		arrows: true,
		dots: false,
		slidesToShow: 1,
  		slidesToScroll: 1,
  		responsive: [
		  {
	  		breakpoint: theme.cache.md,
	  		settings: {
		  		infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true
	 		 }
		  }
		]
	});
}

/**
 * Init Template slider 
**/
theme.templateSlider = function() {
	theme.cache.$templateSlider.each(function() {
		
		var $this = $(this),
		  initialized = $this.hasClass('slick-initialized'),
		  slideLength = $this.data('slide-length'),
		  noSlider = $this.data('no-slider');
		  
		// Stop unslick with breakpoint
		if (noSlider == 'unslick-md' && theme.cache.viewportWidth >= theme.cache.md) return;  
		
		// Return if already initialised
		if (initialized) return;
		
		$this.slick({
			arrows: true,
	  		dots: false,
			slidesToShow: slideLength,
	  		slidesToScroll: 1,
			responsive: [
			  {
				breakpoint: theme.cache.md,
				settings: {
					centerMode: true,
					centerPadding: '55px',
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false
				 }
			  }
			]
		});
	});
}

/**
 * Init Template slider 
**/
theme.relatedSlider = function() {
	var initialized = theme.cache.$relatedSlider.hasClass('slick-initialized'),
	  slideLength = theme.cache.$relatedSlider.data('slide-length');
	
	// Return if already initialised
	if (initialized) return;
	
	theme.cache.$relatedSlider.slick({
		centerMode: true,
  		centerPadding: '-10px',
		arrows: true,
  		dots: false,
		slidesToShow: slideLength,
  		slidesToScroll: 1,
		slidesPerRow: 1,
		responsive: [
		  {
	  		breakpoint: 1026,
	  		settings: {
				slidesToShow: slideLength,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '0px',
				dots: false,
				arrows: true
	 		 }
		  },
		  {
	  		breakpoint: 991,
	  		settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '50px',
				dots: false,
				arrows: true,
				rows: 1
	 		 }
		  },
		  {
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '45px',
				dots: false,
				arrows: true
			}
		  }
		]
	});
}

/**
 * Live search 
**/
theme.liveSearch = function() {
	var cleared = false, keyUpLimit = 2, imageSize = '180x180_crop_center', html,
	  $loader = $('.search-form .search-loader');
	
	//  Search. On key up, count characters and if greater than 2, prepare data and console.log the value.
	var data = {
		s: null,
		resources: {
			"types": ["product"],
			"limit": 4,
			"options": {
				"fields": "title,variants.title,tag,variants.sku",
				"unavailable_products": "hide"
			}
		}
	};
	
	function fail(r) { console.log('fail', r); }
	
	function success(r) {
		// Check if the research was cleared by the user
		if (cleared) return;
		
		// Reset HTML
		html = '<h4 class="mb-4 mb-lg-5">Product Suggestions</h4><div class="list">';
		$loader.addClass('off');
		
		// If array of products is zero, display no results
		if (r.resources.results.products.length == 0) {
			html += '<div class="m-0 py-2">No results!<div>';
		//else iterate through products and show product titles
		} else {		
			$.each(r.resources.results.products, function(index, product) {
				var img = slate.Image.getSizedImageUrl(product.image, imageSize);
				html += '<div class="media active mb-3"><div class="media-body align-self-center"><a href="'+product.url+'" title="'+product.title+'">'+product.title+'</a></div><a href="'+product.url+'"><img class="img-fluid align-self-center ml-3 prd-img" src="'+img+'" alt="'+product.title+'"></a></div>'; 
			});
		}
		
		// Close product list
		html += '</div>';
		
		// Clear prediction dislay
		theme.cache.$searchPredictions.addClass('on').html(html);
	}
	
	// On search when user releases a key trigger ajax function for searching recommended product results
	theme.cache.$searchInput.on('keyup', function() {
		var value = $(this).val();
		//if value is greater than 2, call ajax function to get data.
		if (value.length > keyUpLimit) {
			// Reset cleared status
			cleared = false;
			data.s = value;
			theme.ajax({ method: 'GET', url: '/search/suggest.json' }, data, success, fail);
			$loader.removeClass('off');
		} else {
			// Hide
			theme.cache.$searchPredictions.removeClass('on');
			theme.cache.$searchPredictions.empty();
		}
	});
	
	
	// On search clear
	theme.cache.$searchInput.on("search", function(event) {
		cleared = true;
		theme.cache.$searchPredictions.removeClass('on');
		$loader.addClass('off');
	});
	
	// Manage AUTO Focus
	$('[data-target="#navbarSearch"]').on('click', function(e) {
		if (e.currentTarget.getAttribute('aria-expanded') == 'false') {
			setTimeout(function() {
				theme.cache.$searchInput.focus();
			}, 300);
		} else {
			theme.cache.$searchInput.blur();
		}
	});
}

/**
 * AJAX calls
**/
theme.ajax = function(options, data, callback, callbackFail) {
	var com;
	// Set up defaults
	if (!options) return false;
	// Setup Ajax
	$.ajaxSetup(options);
	
	if (options.dataType == 'jsonp')
		com = $.ajax({ data: data });
	else if (options.data)
		com = $.ajax();	
	else
		com = $.ajax({ data: data });
	
	com.done(function(res) {
		if (callback)
			return callback(res);
	})
	.fail(function(jqXHR, textStatus, errorThrown) {
		if (callbackFail)
			return callbackFail;
	});
}

/* *****************************************
	FORMS VALIDATION
***************************************** */
/**
 * Form validation - using parsley
**/
theme.formsValidation = function($forms) {
	var a = $forms.parsley();
	console.log(a);
}

/*******************************************
	MAILCHIMP
*******************************************/
theme.mailchimp = function() {
	theme.cache.$mailchimpForm.on('click', 'button', function(e) {
		e.preventDefault();
		// e.stopPropagation();

		var $this = $(this),
		  $form = $this.parents('form'),
		  data, emailInvalid, options, success, fail,
		  $emailError = $form.find('.error-email'),
		  $errorMessage = $form.find('.error-message'),
		  $emailInput = $form.find('.mce-EMAIL'),
		  $btnSubscribe = $form.find('.btn');

		  
		// AJAX FORM
		data = {};
		data.email = $form.find('[name="EMAIL"]').val();
		options = {url: $form.attr('action'), method: 'POST', dataType: 'json', cache: false, data: $form.serialize()};
		emailInvalid = (!data.email || data.email.length < 8 || (data.email.indexOf('@')<0) || (data.email.indexOf('.')<0));

		if (emailInvalid) {
			$errorMessage.removeClass('invisible d-none').addClass('visible d-block');
		} else {
			// RESET errors
			console.log('reset errors');
			$errorMessage.removeClass('visible d-block').addClass('invisible d-none');
		}
		
		// Bots
		if (emailInvalid) return false;

		// Update text		
		$this.text('Sending...');

		// Callbacks
		success = function(r) {
			//disable the buttons and the input and display a thank you message, make button light brown
			if (r.result == 'success') {
				$this.text('Thank You!');
				//add attribute/prop disabled to true to inputs
				$emailInput.prop('disabled', true);
				$btnSubscribe.addClass('btn-ok');
			} else {
				//on error add text oops to button and show please enter message
				$errorMessage.removeClass('invisible d-none').addClass('visible');
				$errorMessage.find('div').text('This email is already registered.');
				$btnSubscribe.removeClass('btn-ok');
				$this.text('Oops!');
				var t = setTimeout(function() {
					$this.text( $this.data('original-copy') );
					$emailInput.prop('disabled', false);
				}, 2800);
			}
		};
		fail = function(r) {
			console.log('fail', r);
			$this.text('Error!');
		};

		theme.ajax(options, data, success, fail);
		return false;
	});
};

/**
 * Fix iOS bug in CSS vh
**/
theme.iosBadVH = function() {
	// fix iOS bug in CSS vh
	// https://gist.github.com/pburtchaell/e702f441ba9b3f76f587
	var isBadIos = function() {
		var regex = /(iPhone|iPad|iPod);[^OS]*OS (\d)/;
		var matches = navigator.userAgent.match(regex);
		if (!matches) return false;
			return matches[2] < 8;
	}
	
	if (isBadIos()) {
		var h = document.documentElement.clientHeight || 0;
		if (h && !theme.cache.$heroHome.hasClass('hero-for-video')) theme.cache.$heroHome.height(h+1);
	}
}

/**
	* Listen to click on element
	* displaying data-to-scroll.
	* data-scroll-speed is optional
**/
theme.toScroll = function() {
	theme.cache.$toScroll.on('click', function(e) {
		var h = e.currentTarget.hash || null,
		  s = $(this).attr('data-scroll-speed') || null;
		if (h) {
			e.preventDefault();
			theme.scroller(h, s);
		}
	});
}

/**
	* Scroll viewport to position
	* @param {String} hash
	* @param {Number} duration
	* @param {Function} cb
**/
theme.scroller = function(hash, duration, cb) {
	var target = $(hash),
	  dur = duration || 800;

	if (target.length) {
		theme.cache.$body.animate({
			scrollTop: target.offset().top
		}, dur, 'easeInCubic')
		.promise().done(cb);
	}
	return;
}


// Helper
jQuery.extend(jQuery.easing, {
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	}
});


/** * INIT * **/
$(theme.init());